/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Professionals1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import ExternalProfessionals from './ExternalProfessionals/index'
import PastProfessionals from './PastProfessionals/index'
import Professionals from './Professionals/index'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaCardHeader from 'DesignSystem/TysiaCard/TysiaCardHeader/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import Tysiav2Professionals from 'DesignSystem/Svgs/Tysiav2Professionals/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Professionals1({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals"
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
 paddingTop={dtSpaceLs}
 paddingBottom={dtSpaceLs}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 borderBottomColor={dtColorsNeutral200}
 borderBottomWidth={1}
>
{childProps => (
<div
  data-testid="Professionals.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Professionals.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z2wr7SS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2Professionals
  viewPath={`${viewPath}/Tysiav2Professionals`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Professionals"
/>
</div>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 paddingTop={0}
 flexDirection="column"
 overflowX="visible"
 overflowY="visible"
>
{childProps => (
<React.Fragment>
<Professionals
{...childProps}
  viewPath={`${viewPath}/Professionals`}
/>
<TysiaHorizDivider
{...childProps}
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginTop={0}
 marginBottom={0}
 backgroundColor={dtColorsNeutral200}
/>
<ExternalProfessionals
{...childProps}
  viewPath={`${viewPath}/ExternalProfessionals`}
/>
<TysiaHorizDivider
{...childProps}
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginTop={0}
 marginBottom={0}
 backgroundColor={dtColorsNeutral200}
/>
<PastProfessionals
{...childProps}
  viewPath={`${viewPath}/PastProfessionals`}
/>
</React.Fragment>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}